import { JSX, useContext, useState } from "react";
import { toast } from "react-toastify";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";
import { SkipTimeDistanceRecalcCallout } from "@app/shared/terminations/SkipTimeDistanceRecalcCallout";

interface TerminationsWizardFlyoutProps {
  isSkipSelected: boolean;
  onSubmit: () => Promise<boolean>;
}

const TerminationsWizardFlyout = (props: TerminationsWizardFlyoutProps): JSX.Element => {
  const [submitting, setSubmitting] = useState(false);
  const flyoutContext = useContext(FlyoutContext);

  const errorMessage = () => {
    toast("Something went wrong. Please try again later.",
      {
        containerId: "z-index-9999",
        type: "error",
      });
    setSubmitting(false);
  };

  const handleSubmit = () => {
    if (submitting) {
      return;
    }
    setSubmitting(true);
    props.onSubmit().then((result: boolean) => {
      if (result) {
        toast("Your terminations are being processed.", {
          containerId: "z-index-9999",
          type: "success",
        });
        flyoutContext.handleCloseFlyout();
      } else {
        errorMessage();
      }
    },
      () => { errorMessage(); });
  };

  return (
    <>
      <div className="terminations-wizard-flyout">
        <p className="lead">
          <QesIcon iconName={QesIcons.AlertTriangle} description="Warning" className="align-text-top me-3" />
          Are you sure?
        </p>
        <hr />
        <div>
          <p>While the termination is running the projects you selected will no longer be able to:</p>
          <ul>
            <li>Make changes</li>
            <li>Make updates</li>
            <li>Generate additional terminations</li>
          </ul>
          <p>Any project with existing terminations will be overwritten and not appended.</p>
          <SkipTimeDistanceRecalcCallout isSkipSelected={props.isSkipSelected} />
          <p className="demibold">Once the termination has been started there will be no way to cancel it.</p>
        </div>
      </div>
      <FlyoutFooter
        submitButton={
          <QESButton qesType="primary" className="ms-3" onClick={handleSubmit} disabled={submitting} qesTestId="import-terminations__flyout-run">
            {submitting ? (
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : "Run Now"}
          </QESButton>
        }
      />
    </>
  );
};

export default TerminationsWizardFlyout;
